'use strict';
module.exports = {
    cmInchTabs: function() {
        $('.inched-centimeter-tab a').on('click', function(e) {
            e.preventDefault();
            var $this = $(this);
            var $data = $this.data('type');
            var $parent = $this.parent();

            $parent.addClass('active').siblings().removeClass('active');

            if ($data == 'inch') {
                $('.sizeGuide-container .inch-value').show();
                $('.sizeGuide-container .cm-value').hide();
            } else {
                $('.sizeGuide-container .inch-value').hide();
                $('.sizeGuide-container .cm-value').show();
            }
        })
    }
}